export enum ApiExceptions {
    CUSTOMER_HAS_NOT_NEXPARK_URL = 'CUSTOMER_HAS_NOT_NEXPARK_URL',
}
